<template>
  <div class="body-width divcss5">
    <div>
      <div class="div-row div-bottom news-Medium-24">
        海大智龙隆重推出“线上GMDSS培训软件” 助力航海院校共击疫情
        <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
      </div>
           <div class="div-text-left news-Regular-14b6">
            <span>2020-04-20</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
           </div>
      <div class="div-line  divcss5"></div>
      <div class="div-row div-bottom10">
          <p class="indentation">
         大连海大智龙隆重推出线上GMDSS培训软件，包括最新FURUNO系列及SAILOR系列等10种设备。请登录海大智龙官网www.zlonmarine.com的产品中心之在线产品试用，疫情期间免费。加上之前推出的四种船型配载软件，ECDIS软件，雷达模拟软件，在线VR实训软件及操纵避碰在线考试软件，海大智龙助力航海院校和船员公司共击疫情，竭力提升航海教育的实训能力，欢迎各位同仁试用并反馈宝贵意见建议！
        </p>
        
      </div>
      <div class="div-row div-bottom10">
        <div class="  div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news14/1.png" />
          </div>
        </div>
      </div>
      <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news14/3.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news14/2.png" /> &nbsp;&nbsp;
             <img src="../../../assets/images/news14/4.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news14/5.png" />
          </div>
        </div>
      </div>
         <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news14/6.png" /> &nbsp;&nbsp;
               <img src="../../../assets/images/news14/7.png" />
          </div>
        </div>
      </div>
        <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news14/8.png" />
      
          </div>
        </div>
      </div>
        <div class="div-row div-bottom10">
        <div class=" div-top box2">
          <div class="div-margin ">
            <img src="../../../assets/images/news14/9.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }
  img {
    vertical-align: middle;
    border-style: none;
    width: 100%; 
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news14.vue